import React from "react";
import { classNames } from "../../../../helpers/classNames";
import { useBanner } from "../../../../providers/BannerProviders";

const StatisticsItem = ({ data }) => {
  return (
    <div
      className={classNames(
        "relative lg:border-r lg:border-shades-07 last:lg:border-none py-8 lg:py-4 px-4",
        "after:hidden after:content-[''] after:lg:flex after:last:hidden after:absolute after:-top-1 after:xls:-top-1.5 after:-right-1 after:xls:-right-1.5 after:w-2 after:xls:w-3 after:aspect-square after:bg-chestnut-rose after:rounded-full after:z-[1]"
      )}
    >
      <div className="flex flex-col items-center gap-4 text-center">
        <div className="text-4xl whitespace-nowrap xls:text-5xl text-chestnut-rose font-semibold font-CanelaDeck">
          {data?.count}
        </div>
        <div className="text-sm sm:text-base xls:text-lg xl:text-xl font-semibold">
          {data?.title}
        </div>
      </div>
    </div>
  );
};

const ScholarshipStatisticsSection = () => {
  const { data } = useBanner();
  const homeBanner = data?.data?.find((item) => item?.bannerType === "home");

  const statisticsData = [
    homeBanner?.details?.existence,
    homeBanner?.details?.scholarAward,
    homeBanner?.details?.beneficiary,
    homeBanner?.details?.fundDistribution,
  ];

  return (
    <>
      <section className="relative flex w-full py-16 xls:py-24 bg-chestnut-rose/10">
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-full mx-auto px-4">
          <div className="grid grid-cols-2 lg:grid-cols-4">
            {statisticsData?.map((item, index) => (
              <StatisticsItem key={index} data={item} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ScholarshipStatisticsSection;
